import React from 'react'
import classNames from 'classnames'

import { EDITOR_CONTENT } from 'components/Layout/NoteView'

export const HeaderLayout = ({ children }) => (
  <div
    className={classNames('position-fixed zindex-huge width-full')}
    style={{ height: 58, top: 0 }}
  >
    {children}
  </div>
)

export const NoteContainerLayout = ({ children }) => (
  <div
    className="public-note height-full-page position-relative scrollable"
    style={{ paddingTop: 60, WebkitOverflowScrolling: 'touch' }} //Keep scrolling inertia on iOS devices
  >
    {children}
  </div>
)

export const NoteLayout = ({ children }) => (
  <div className="width-full overflow-hidden">
    <div
      id={EDITOR_CONTENT}
      className="public-note-inner width-full margin-left-auto margin-right-auto"
      style={{ maxWidth: 900, minWidth: 0 }}
    >
      {children}
    </div>
  </div>
)

export const NoteTitle = ({ children }) => (
  <div
    className="note-editor-title font-weight-bold font-size-largest"
    style={{ marginTop: 0 }}
  >
    {children}
  </div>
)

export const Error = () => (
  <div
    className="background-shade-100 radius-normal margin-large padding-large"
    style={{ width: 520, margin: '30px auto' }}
  >
    <h1 className="margin-bottom-normal">
      Oh... it looks like we can't find this doc.
    </h1>
    <p>It might have been deleted by its owner.</p>
  </div>
)
